import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";

import FacebookButton from "components/Auth/FacebookButton";
import GoogleButton from "components/Auth/GoogleButton";

import withNoAuthentication from "hocs/withNoAuthentication";
import withMainLayout from "hocs/withMainLayout";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  frame: {
    margin: theme.spacing(2),
    padding: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
      margin: 0,
    },
    textAlign: "center",
  },
  buttons: {
    "& > :first-child": {
      marginBottom: theme.spacing(2),
    },
  },
}));

const Home = () => {
  const classes = useStyles();
  return (
    <Container
      maxWidth="sm"
      className={classes.container}
    >
      <Paper className={classes.frame}>
        <Typography variant="h6" className="bold">
          Rather Wiki
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Byte-sized Blockchain Posts
        </Typography>
        <Divider variant="middle" />
        <Box className={classes.buttons}>
          <GoogleButton fullWidth />
          <FacebookButton fullWidth />
        </Box>
      </Paper>
    </Container>
  );
};

export default withMainLayout(withNoAuthentication(Home));
